import { gql } from "@apollo/client";

export const ODOO_SAVE_CUSTOMER = gql`
  mutation ODOO_SAVE_CUSTOMER(
    $instance: String!
    $id: Int!
    $xStudioMtRetailerId: String
    $xStudioMtAddressId: String
    $xStudioMtRepgroupId: String
    $xStudioSpsVendorNumber: String
    $xStudioSpsLocationNumber: String
  ) {
    odooSaveCustomer(
      instance: $instance
      id: $id
      xStudioMtRetailerId: $xStudioMtRetailerId
      xStudioMtAddressId: $xStudioMtAddressId
      xStudioMtRepgroupId: $xStudioMtRepgroupId
      xStudioSpsVendorNumber: $xStudioSpsVendorNumber
      xStudioSpsLocationNumber: $xStudioSpsLocationNumber
    ) {
      result
    }
  }
`;
